// extracted by mini-css-extract-plugin
export default {"geschichte-container":"geschichte_geschichte-container__-Acrb","geschichte-title":"geschichte_geschichte-title__c7mLf","geschichte-img":"geschichte_geschichte-img__avNG2"};